import React, { useContext, useCallback, useMemo } from 'react'
import { Box, ResponsiveBox } from '@usap/uicomponents'
import { LocalContext } from '../../helpers/useLocalContext'
import { queryFactory } from '../../helpers'
import { useVehicleContext } from '../../contexts/vehicle.context'
import Notification from '../searchLayoutComponents/Notification'
import SidebarSection from '../searchLayoutComponents/SidebarSection'
import MainSection from '../searchLayoutComponents/MainSection'
import SearchContextProvider from './context/SearchContextProvider'
import { isSEOPage } from '../../helpers/searchBoxFactory'

const regexToRemoveCurrentPage = /&currentpage(?:=[^&]*)?(?=&|$)|^currentpage(?:=[^&]*)?(?:&|$)/
const wrapFlag = true

const style = {
  wrapper: {
    margin: { large: { vertical: '0', horizontal: 'auto' } },
    width: '1248px',
  },
  grid: {
    default: { alignSelf: 'flex-start', width: '100%' },
    gap: { large: 'medium' },
  },
  sidebar: {
    width: { large: '18%', other: '0%' },
  },
  mainSection: {
    width: { large: '82%', other: '100%' },
  },
}

export default function SearchLayout(props) {
  const {
    id,
    isComponentChanged,
    sortOptions,
    isSearch,
    title,
    products,
    removePrice = true,
    pageType,
    coreConfig,
  } = props

  const { vehicleKeyword = '' } = products

  const { localContext } = useContext(LocalContext)
  const { history } = localContext

  const vehicleState = useVehicleContext()
  const { vehicleDB = [] } = vehicleState

  const toggleItemsPerPage = useCallback(
    (key, value, isRemoveAction) => {
      const pathName = window.location.pathname || history.location.pathname
      const selectedVehicle = isSEOPage(window.pageType)
        ? {}
        : vehicleDB && vehicleDB.find(element => element.selected)

      let query = queryFactory.findAndReplaceUrlParam(
        key,
        value,
        selectedVehicle,
        isRemoveAction,
      )
      query = key === 'currentpage'
        ? query
        : query.replace(regexToRemoveCurrentPage, '')

      return history.push({
        pathname: pathName || '/search',
        search: query,
      })
    },
    [history, vehicleDB],
  )

  const searchContextValue = useMemo(() => (
    {
      pageTypeId: id,
      products,
      sortOptions,
      sidebarStatus: false,
      title,
      isSearch,
      isComponentChanged,
      pageType,
    }
  ), [id, isComponentChanged, isSearch, pageType, products, sortOptions, title])

  if (vehicleKeyword) return null

  return (
    <SearchContextProvider initialValue={searchContextValue}>
      <ResponsiveBox
        id={id}
        width={style.wrapper.width}
        fxMargin={style.wrapper.margin}
      >
        <Notification />

        <Box pad="small" wrap={wrapFlag} gap="small">
          <ResponsiveBox
            id={`${id}Grid`}
            style={style.grid.default}
            direction="row"
            fxGap={style.grid.gap}
          >
            <ResponsiveBox
              id="SideBarSection"
              fxWidth={style.sidebar.width}
            >
              <SidebarSection
                toggleItemsPerPage={toggleItemsPerPage}
              />
            </ResponsiveBox>

            <ResponsiveBox
              id="MainSection"
              fxWidth={style.mainSection.width}
            >
              <MainSection
                toggleItemsPerPage={toggleItemsPerPage}
                removePrice={removePrice}
                pageType={pageType}
                coreConfig={coreConfig}
              />
            </ResponsiveBox>
          </ResponsiveBox>
        </Box>
      </ResponsiveBox>
    </SearchContextProvider>
  )
}
